module.exports = __webpack_public_path__ + "static/media/avenir-next-bold.ffff0131.woff";